import { useCallback, useSyncExternalStore } from "react";

import {
  getSoundPreferences,
  setSoundPreference,
  subscribeSoundPreferences,
  type SoundPreferences,
} from "@/lib/audio/preferences";
import { setCueVolume } from "@/lib/audio/tones";

export function useSoundPreferences(): {
  preferences: SoundPreferences;
  set: <K extends keyof SoundPreferences>(key: K, value: SoundPreferences[K]) => void;
} {
  const preferences = useSyncExternalStore(subscribeSoundPreferences, getSoundPreferences);

  const set = useCallback(
    <K extends keyof SoundPreferences>(key: K, value: SoundPreferences[K]) => {
      setSoundPreference(key, value);
      if (key === "volume") setCueVolume(getSoundPreferences().volume);
    },
    [],
  );

  return { preferences, set };
}
